<section class="container py-2">
  <div class="row">
    <div class="col-12 col-md ">
      <input class="p-1 fs-sm" type="search" placeholder="جستجو" name="keyword" [(ngModel)]="criteria.Keyword" (change)="load()">
    </div>
    <div class="form-group col-md">
      <ng-select name="tags" [multiple]="true" [addTag]="addTag" [(ngModel)]="criteria.Tags" addTagText="افزودن"
        [selectOnTab]="true" placeholder="جستجوی تگ ها" notFoundText="" (change)="load()"></ng-select>
    </div>
    <div class="col-12 col-md">
      <select class="p-1 fs-sm" [(ngModel)]="status" name="filterstatus" (change)="load()">
        <option [value]="-1" class="f-gray">وضعیت انتشار</option>
        <option [value]="0">پیشنویس</option>
        <option [value]="1">در انتظار تایید</option>
        <option [value]="2">منتشر شده</option>
        <option [value]="3">آرشیو شده</option>
      </select>
    </div>
    <div class="col-2">
      <a class="btn btn-yellow btn-sm" (click)="openModal()">افزودن محتوا</a>
    </div>

  </div>

  <section *ngIf="contents?.length">
    <div class="col-12 text-center">
      <app-pagination [total]="total" [limit]="limit" (page)="load($event)"></app-pagination>
    </div>

    <section class="container">
      <div *ngFor="let content of contents;let i=index" class="row d-block rounded-xl shadow-kp p-2 m-2">
        <div class="col-12">
          <header class="fs-sm f-gray">
            <span class="fs-normal badge light-gray-bg p-1">
              <span class="f-gray" *ngIf="content.Status==0">پیش‌نویس</span>
              <span class="f-yellow" *ngIf="content.Status==1">در انتظار تایید</span>
              <span class="f-green" *ngIf="content.Status==2">منتشر شده</span>
              <span class="f-red" *ngIf="content.Status==3">آرشیو شده</span>
            </span>
            تولید: {{content.RegisterTime|pdate}}
            <span class="f-blue"> | ویرایش: {{content.UpdateTime|pdate}}</span>
            <span class="float-left fs-xl">
              <i class="fa fa-edit pointer mx-2 f-blue" (click)="openModal(content)" title="ویرایش"></i>
              <i class="fa fa-trash pointer mx-2 f-red" *ngIf="content.Status!==3" (click)="delete(content.Id)"
                title="حذف"></i>
            </span>

          </header>
          <div class="d-flex">
            <img *ngIf="content.Image" style="max-width:150px;max-height:150px"
              [src]="content.Image?.startsWith('http') ? content.Image : imageUrl+content.Image">
            <a class="col" [routerLink]="['/content',content.Id]" target="_blank">
              <h5>{{content.Title}}</h5>
            </a>
          </div>
          <div class="row">
            <span class="badge border fs-sm m-1">{{[content.State, content.City].join('،')}}</span>
            <span class="badge badge-dark fs-sm m-1" *ngFor="let keyword of content.Keywords">{{keyword}}</span>
            <span class="badge badge-light fs-sm m-1" *ngFor="let tag of content.Tags">{{tag}}</span>
          </div>
        </div>
      </div>
    </section>
    <div class="col-12 text-center">
      <app-pagination [total]="total" [limit]="limit" (page)="load($event)"></app-pagination>
    </div>

  </section>
</section>

<ngx-smart-modal #contentModal identifier="contentModal">
  <section class="container relative p-3">
    <ngx-spinner name="action" [fullScreen]="false" type="timer"></ngx-spinner>
    <form #contentForm="ngForm" class="row">
      <div class="form-group col-4">
        <input type="file" #file (change)="loadImage(file.files[0])" style="display:none;" accept=".jpg,.jpeg,.png">
        <ng-container *ngIf="!((image && preview) || selected.Image)">
          <button class="btn btn-white" type="button" (click)="file.click()">انتخاب تصویر</button>
        </ng-container>
        <ng-container *ngIf="(image && preview) || selected.Image">
          <i class="fa fa-times fs-xl f-red mx-3" (click)="removeImage(file)"></i>
          <img [src]="preview||imageUrl+selected.Image" class="ml-3" style="max-height:80px">
        </ng-container>
  
  
      </div>
  
      <div class="form-group col-12 col-md-4">
        <input type="text" name="title" required placeholder="عنوان" [(ngModel)]="selected.Title">
      </div>
      <div class="form-group  col-12 col-md-4">
        <select [(ngModel)]="selected.Status" class="form-control" name="status">
          <option [value]="0">پیشنویس</option>
          <option [value]="1">در انتظار تایید</option>
          <option [value]="2">منتشر شده</option>
          <option [value]="3">آرشیو شده</option>
        </select>
      </div>
  
      <div class="form-group col-4">
        <app-location name="location" [(ngModel)]="selected" placeholder="شهر"></app-location>
      </div>
      <div class="form-group col-4">
        <ng-select name="keywords" [multiple]="true" [addTag]="addTag" [(ngModel)]="selected.Keywords" addTagText="افزودن"
          [selectOnTab]="true" placeholder="لیست کلمات کلیدی" notFoundText=""></ng-select>
      </div>
      <div class="form-group  col-4 ">
        <ng-select name="tags" [multiple]="true" [addTag]="addTag" [(ngModel)]="selected.Tags" addTagText="افزودن"
          [selectOnTab]="true" placeholder="لیست تگ ها" notFoundText=""></ng-select>
      </div>
      <div class="form-group col-12">
        <angular-editor placeholder="متن" name="body" [(ngModel)]="selected.Body"
          [config]="Common.EditotConfig_Operator"></angular-editor>
  
        <!-- <app-ngx-editor name="body" placeholder="متن" height="300px" [(ngModel)]="selected.Body"
          [toolbar]='[["bold","unorderedList","orderedList"],["link", "unlink"]]'>
        </app-ngx-editor> -->
      </div>
  
  
      <div class="cross-validation-error-message alert alert-danger"
        *ngIf="contentForm.invalid && (contentForm.touched || contentForm.dirty)">
        لطفا در وارد کردن فیلدهای مورد نظر را دقت فرمایید
        <!-- {{form.controls.description.errors}} -->
      </div>
      <div class="col-12 text-left">
        <button class="btn btn-yellow " type="submit" (click)="save()" [disabled]="contentForm.invalid">ذخیره</button>
      </div>
    </form>
  </section>
</ngx-smart-modal>